import React from 'react';
import ReactDOM from 'react-dom';
import { Router } from 'react-router-dom';
import { createBrowserHistory } from "history";
import { App } from "./App";
import 'swiper/css/bundle';
import './styles/global.scss';

const history = createBrowserHistory();
const root = document.getElementById('pc-react-app');

window.customHistory = history;

ReactDOM.render(
  <React.StrictMode>
    <Router history={history}>
      <App onlyPlanPopup={root.dataset.onlyPlanPopup} />
    </Router>
  </React.StrictMode>,
  root
);
